<DumbModal :title="t('operation_completed')" @hide="hideModal()">
    <div class="top-part">
        <span class="material-icons confirm-icon margin-top-20">check_circle_outline</span>
        <p class="confirm-text">{{t('operation_completed_success')}}</p>
    </div>
    <div class="button-row flexbox-column align-center">
        <p class="abort" @click="hideModal()">{{uppercase(t('close'))}}</p>
    </div>
</DumbModal>